import React from 'react'

export default class ProfissaoAi extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="form-group row mt-5 text-left">
                    <label className="col-6 col-md-6">Profissão:</label>
                    <div className="col-6 col-md-6 mb-3">
                        <select className="custom-select"
                            name="profissaoAi"
                            {...this.props}
                            value={this.props.value.profissaoAi} >
                            <option value=""></option>
                            <option value="Fisioterapia">Fisioterapia</option>
                            <option value="Terapia Ocupacional">Terapia Ocupacional</option>
                        </select>
                    </div>
                </div>
                <br /><hr />
            </React.Fragment>
        )
    }
}